// reactivate-dialog.component.ts
import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface ReactivateDialogData {
  organizationName: string;
  userCount?: number;
}

@Component({
  selector: 'app-reactivate-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  template: `
    <h2 mat-dialog-title>
      <mat-icon color="primary">refresh</mat-icon>
      Reactivate Organization
    </h2>
    <mat-dialog-content>
      <p>Are you sure you want to reactivate <strong>{{ data.organizationName }}</strong>?</p>
      
      <div class="info-box">
        <mat-icon>info</mat-icon>
        <div>
          <p><strong>This will:</strong></p>
          <ul>
            <li>Reactivate the organization in the system</li>
            <li>Unlock all associated user accounts</li>
            <li>Restore full access for practitioners</li>
            <li>Make the organization visible in active lists</li>
          </ul>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-flat-button color="primary" (click)="onConfirm()">
        <mat-icon>check</mat-icon>
        Reactivate
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content {
      min-width: 450px;
    }

    .info-box {
      display: flex;
      gap: 12px;
      padding: 16px;
      background: #e3f2fd;
      border-left: 4px solid #1976d2;
      border-radius: 4px;
      margin-top: 16px;
    }

    .info-box mat-icon {
      color: #1976d2;
      flex-shrink: 0;
    }

    .info-box p {
      margin: 0 0 8px 0;
    }

    .info-box ul {
      margin: 0;
      padding-left: 20px;
    }

    .info-box li {
      margin-bottom: 4px;
      font-size: 0.875rem;
    }
  `]
})
export class ReactivateDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ReactivateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReactivateDialogData
  ) {}

  onConfirm() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}